import { graphql, Link } from "gatsby"
import { motion, useInView } from "framer-motion"
import React, { useEffect, useRef, useState } from "react"
import parse from "html-react-parser";

const GetInTouchBox = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  if (module.hideSection === "no") {
    return (
      <section
        className={`booktable-listing ${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <div className="bg-white-100 px-80 py-50 lgscreen:py-30 lgscreen:px-40 mdscreen:px-20">
          <motion.div
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="anim"
          >
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="flex flex-wrap -mx-25 mdscreen:mx-0 gap-y-[25px]"
            >
              {module.getInBox &&
                module.getInBox.map((item, i) => (
                  <div
                    className="lg:w-4/12 md:w-6/12 w-full px-25 mdscreen:px-0"
                    key={i}
                  >
                    <motion.div variants={animFade} className="border-1 border-charcoal rounded-2 py-45 text-center h-[14rem] lgscreen:min-h-[240px] lgscreen:flex lgscreen:flex-col lgscreen:justify-center">
                      {item?.heading && <h5>{parse(item.heading)}</h5>}
                      <div className="flex flex-col justify-center gap-x-[5px] gap-y-2 pt-10">
                        {item?.phoneNumber && (
                          <div className="flex flex-wrap justify-center gap-x-[5px]">
                            <img
                              src="../images/phone.svg"
                              loading="lazy"
                              width={11}
                              height={11}
                              alt="phone"
                            />
                            <Link
                              to={`tel:${item.phoneNumber}`}
                              className="font-ositalic text-13 underline hover:opacity-70"
                            >
                              {item.phoneNumber}
                            </Link>
                          </div>
                        )}
                        {item?.emailAddress && (
                          <div className="flex flex-wrap justify-center gap-x-[5px]">
                            <img
                              src="../images/email.svg"
                              loading="lazy"
                              width={16}
                              height={16}
                              alt="phone"
                            />
                            <Link
                              to={`mailto:${item.emailAddress}`}
                              className="font-ositalic text-13 underline hover:opacity-70"
                            >
                              {item.emailAddress}
                            </Link>
                          </div>
                        )}
                      </div>
                      {item.button && (
                        <div className="mt-20 smscreen:px-20">
                          <Link
                            to={item.button.url}
                            className="btn btn-black"
                            target={item.button.target}
                          >
                            {item.button.title}
                          </Link>
                        </div>
                      )}
                    </motion.div>
                  </div>
                ))}
            </motion.div>
          </motion.div>
        </div>
      </section>
    )
  }
  return null
}

export default GetInTouchBox
export const PageGetInTouchBoxFragment = graphql`
  fragment PageGetInTouchBoxFragment on WpPage_Pagecontent_PageContent_GetInTouchBox {
    extraId
    extraClass
    hideSection
    getInBox {
      button {
        target
        title
        url
      }
      emailAddress
      phoneNumber
      heading
    }
  }
`
